import {
  boxesIntersect,
  getBoxFromPoints,
} from "@/features/Editor/Canvas/canvas-geometry";
import type { Gesture, PressContext } from "./canvas-gesture";

// Pressed on empty canvas outside the selection. Whether the marquee adds to the
// selection is decided by Shift at press time.
export function createMarqueeGesture({
  start,
  canvasElements,
  selectedIds,
  modifiers,
}: PressContext): Gesture {
  const selectedIdsAtStart = modifiers.shift ? selectedIds : [];

  return {
    press: () => ({ selectedIds: selectedIdsAtStart }),
    drag: (point) => {
      const marquee = getBoxFromPoints(start, point);
      const touchedIds = canvasElements
        .filter(({ box }) => boxesIntersect(box, marquee))
        .map(({ externalId }) => externalId);

      return {
        marquee,
        selectedIds: [...new Set([...selectedIdsAtStart, ...touchedIds])],
      };
    },
    click: () => ({}),
  };
}
